import { useTheme } from "@emotion/react";
import { Box, Divider, List, Stack, Typography } from "@mui/material";
import React from "react";

export default function NutritionInformation({ nutrition }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        padding: 2,
        backgroundColor:
          theme.palette.mode === "dark"
            ? theme.palette.background.default
            : theme.palette.background.paper,
        borderRadius: "10px",
        boxShadow: theme.shadows[3],
        border: "1px solid #ccc",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          color: theme.palette.primary.main,
          mb: 2,
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        Nutrition Information
      </Typography>
      <List
        sx={{
          maxHeight: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": { display: "block" },
          "-ms-overflow-style": "",
          "scrollbar-width": "2px",
          padding: 0,
        }}
      >
        <Stack direction="column" sx={{ width: "100%" }}>
          {["Calories", "Carbohydrate", "Protein", "Fats"]?.map((nutrient) => (
            <React.Fragment key={nutrient}>
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  py: 2,
                  "&:hover": {
                    backgroundColor: theme.palette.background.default,
                  },
                }}
              >
                <Stack
                  direction="row"
                  flexGrow={1}
                  justifyContent="space-between"
                >
                  <Stack direction="row">
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{
                        display: "block",
                        ml: 1,
                        fontWeight: "bold",
                      }}
                    >
                      {nutrient}
                    </Typography>
                  </Stack>
                  <Stack direction="row">
                    <Typography
                      variant="body1"
                      component="div"
                      sx={{
                        display: "block",
                        color: theme.palette.primary.main,
                      }}
                    >
                      {!nutrition
                        ? "N/A"
                        : nutrient === "Calories"
                        ? `${nutrition[nutrient.toLowerCase()] || "0"} Cal`
                        : `${nutrition[nutrient.toLowerCase()] || "0"} g`}
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
              <Divider sx={{ borderColor: "#ccc" }} />
            </React.Fragment>
          ))}
        </Stack>
      </List>
    </Box>
  );
}
